<template>
  <div class="container-services">
    <CarrouselPropio :testimonios="testimonios" />
  </div>
</template>

<script>
import CarrouselPropio from './PublicComponents/CarrouselPropio.vue';
import TestimoniosService from '@/services/testimonios.service';
export default {
    name: "Testimonios",
    components: { CarrouselPropio },
    data() {
        return {
            testimonios: [],
            testimoniosService: null,
        };
    },
    created() {
        this.testimoniosService = new TestimoniosService();
    },
    mounted() {
        this.testimoniosService
            .getTestimonios()
            .then((res) => {
                if (res.data.data && res.data.data.length > 0) {
                    this.testimonios = res.data.data.map((t) => ({
                        persona: t.sesionista,
                        servicio: t.servicio,
                        mensajeEs: t.mensaje_es,
                        mensajeEn: t.mensaje_en,
                        cliente: t.cliente,
                        urlFuente: t.url_fuente || null,
                    }));
                }
            })
            .catch(() => {
                // Fallback al JSON estático si la API falla
                this.testimonios = require('@/assets/data/testimonios.json');
            });
    },
};
</script>

<style scoped>
.container-services {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  padding-top: 60px;
  padding-bottom: 60px;
  justify-content: space-around;
}

@media screen and (max-width: 600px) {
  .container-services {
    padding: 20px;
  }
}
</style>
